module.exports = __webpack_public_path__ + "381cf75ad2dcc7b730eb60e40a22c171.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-58.svg
// module id = 586
// module chunks = 0